// Hook custom per ricevere tutti i contratti degli immobili pubblicati dall' agenzia.
// Nota: uso axios e TypeScript per tipizzare la risposta, gestire errori, loading e refetch.
import { useState, useCallback } from 'react';
import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;

// Tipizzazione Parametri dell'hook
interface hookParams {
    agencyId: number;       // ID dell'agenzia
    enabled?: boolean;      // se abilitare la chiamata (utile per componenti condizionali)
}

// Tipizzazione Risultato dell'hook
interface useGetAgencyContractsResult {
    contracts: AgencyContract[] | null;
    loading: boolean;
    error: string | null;
    getAgencyContracts: () => Promise<void>;
}

interface AgencyContract {
    id: number;
    contratto: string;
}
/**
 * useGetAgencyContracts
 * @param agencyId - ID dell'agenzia
 * @returns - Array con tutti i contratti degli immobili pubblicati dall'agenzia
*/

const useGetAgencyContracts = ({
    agencyId,
    enabled = false
}: hookParams): useGetAgencyContractsResult => {
    const [contracts, setContracts] = useState<AgencyContract[] | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const getAgencyContracts = useCallback(async () => {
        if (!enabled) return;
        try {
            const response = await axios.get<AgencyContract[]>(`${API_BASE_URL}/agency-contracts/${agencyId}`);
            setContracts(response.data);
            setError(null);
        } catch (err: unknown) {
            if (axios.isAxiosError(err)) {
                setError(err.response?.data?.error || err.message);
            } else if (err instanceof Error) {
                setError(err.message);
            } else {
                setError("Errore sconosciuto");
            }
        } finally {
            setLoading(false);
        }
    }, [agencyId, enabled]);

    console.log(contracts)

    return { contracts, loading, error, getAgencyContracts };
};

export default useGetAgencyContracts;